import { cva } from 'class-variance-authority';
import { ReactNode, useState } from 'react';

import { cn } from 'noddi-ui-common';
import { NoddiBasicCard } from '../atoms';
import { webButtonStyling } from '../theme';

type NoddiToolTipProps = {
  content: ReactNode;
  children: ReactNode;
  position?: 'top' | 'right' | 'bottom' | 'left';
};

const tooltipVariants = cva('absolute z-[100000] w-max max-w-xs !shadow-2xl', {
  variants: {
    position: {
      top: 'bottom-full left-1/2 mb-2 -translate-x-1/2 transform',
      right: 'left-full top-1/2 ml-2 -translate-y-1/2 transform',
      bottom: 'left-1/2 top-full mt-2 -translate-x-1/2 transform',
      left: 'right-full top-1/2 mr-2 -translate-y-1/2 transform'
    }
  },
  defaultVariants: {
    position: 'top'
  }
});

// Todo : this components struggles with overflowing the viewport, use floating UI library if we wanna maintain tooltip component ourself, alternatively use the one from Radix UI or something.

export const NoddiToolTip = ({ content, children, position = 'top' }: NoddiToolTipProps) => {
  const [visible, setVisible] = useState(false);

  const handleMouseEnter = () => {
    setVisible(true);
  };

  const handleMouseLeave = () => {
    setVisible(false);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setVisible(!visible);
    }
  };

  return (
    <div className='relative'>
      <button
        className={webButtonStyling}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onKeyDown={handleKeyDown}
        type='button'
      >
        {children}
      </button>
      {visible && (
        <NoddiBasicCard className={cn(tooltipVariants({ position }), 'bg-white text-black')}>{content}</NoddiBasicCard>
      )}
    </div>
  );
};
